import React, { createContext, useContext, useMemo } from "react";
import { useGetBrandBySlugQuery } from "../services/brand";
import config from "../config";

const BrandContext = createContext({
  config: null,
  isLoading: true,
  error: null,
});

export function BrandProvider({ children }) {
  // Brand slug is fixed at build time by REACT_APP_BRAND (default "djr"),
  // the same source src/config uses. It is never read from the page URL.
  const slug = process.env.REACT_APP_BRAND || "djr";

  const { data, isLoading, error } = useGetBrandBySlugQuery(slug, {
    // Keep existing FE working if BE is not ready/seeded
    skip: !config?.api?.baseURL,
  });

  // Fallback to static config when API fails or is loading.
  // When API data is available, shallow-merge over the static config so
  // local-only additions (e.g. `legal`) remain visible until the DB is reseeded.
  const value = useMemo(() => {
    if (data) {
      if (typeof window !== "undefined" && data?.api?.baseURL) {
        window.__API_BASE_URL = data.api.baseURL;
      }
      return {
        config: { ...config, ...data },
        isLoading: false,
        error: null,
      };
    }
    return { config, isLoading, error };
  }, [data, isLoading, error]);

  return (
    <BrandContext.Provider value={value}>{children}</BrandContext.Provider>
  );
}

export function useBrand() {
  return useContext(BrandContext);
}
